/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentExport } from "./AgentExport";
export const GetAgentExportResponse = core.serialization.object({
    data: AgentExport,
});
